<template>
	<div class="single-page-wrap">
		<cube-scroll ref="scroll" class="cube-scroll" :options="scrollOptions">
			<div class="weui-cells" v-if="recordList.length > 0">
				<div class="weui-form__control-area">
					<div class="weui-cells__group weui-cells__group_form">
						<div class="weui-cells weui-cells_checkbox">
							<label class="weui-cell weui-check__label" :for="item.id" v-for="item of recordList">
								<div class="weui-cell__hd" @click="handleChecked(item)">
									<input type="radio" class="weui-check" name="radio" :id="item.id"/>
									<i class="weui-icon-checked"></i>
								</div>
								<div class="cell-wrap">
									<p class="cell-status">
										<span>订单号: {{item.orderSn}}</span>
										<span>{{item.status === 1 ? "已支付" : "未支付"}}</span>
									</p>
									<p class="cell-plate">
										<span>{{item.plateNo || '查看更多车牌'}}</span>
										<span>{{item.money}}元</span>
									</p>
									<!--<div class="change-order" v-if="item.status === 0">-->
									<!--<button class="weui-btn weui-btn_mini weui-btn_default" @click.stop="toCancle(item)">取消订单</button>-->
									<!--<button class="weui-btn weui-btn_mini weui-btn_default" @click.stop="toPay(item)">去支付</button>-->
									<!--</div>-->
									<div class="cell-time" @click.prevent="handleClickCell(item)">
										<p>缴费月份: {{item.payMonth}}</p>
										<p :class="[item.isClickShowColl ? 'spin' : 'reset']">
											<i class="iconfont icon-arrow-bottom"></i>
										</p>
									</div>
									<div class="cell-details-wrap" :class="item.isClickShowColl ? 'show' : 'hidden'">
										<p>停车场: {{item.parkName}}</p>
										<!--<p>缴费月份: {{item.payMonth}}</p>-->
										<p v-if="!clickMerRecord && item.status == 1">开始日期: {{item.startDate}}</p>
										<p v-if="!clickMerRecord && item.status == 1">结束日期: {{item.endDate}}</p>
										<p v-show="item.status == 1 && item.payTime">支付日期: {{item.payTime}}</p>
										<p v-if="item.isClickShowColl && clickMerRecord && (item.pkPlatepaySubList && item.pkPlatepaySubList.length > 0)">缴费车牌:</p>
									</div>

									<div class="single-page-wrap" :class="item.isClickShowColl ? 'show' : 'hidden'"
										 v-if="item.isClickShowColl && clickMerRecord && (item.pkPlatepaySubList && item.pkPlatepaySubList.length > 0)">
										<cube-scroll ref="cellScroll" class="cube-cell-scroll" :options="scrollCellOptions">
											<div class="weui-cells-wrapper" v-for="cell of item.pkPlatepaySubList" :key="cell.id">
												<p class="main-info">
													<span>{{cell.plateNo}}</span>
													<span>{{cell.money}}元</span>
												</p>
												<p class="date-info">
													<!--<span>有效期:</span>-->
													<span>{{cell.startDate}}-{{cell.endDate}}</span>
												</p>
											</div>
										</cube-scroll>
									</div>
								</div>
							</label>
						</div>
					</div>
				</div>

				<p class="total-count">总条数: {{recordList.length}}</p>
			</div>
			<no-data v-else msg="暂无"></no-data>
		</cube-scroll>
		<div class="weui-btn-area">
			<button class="weui-btn weui-btn_primary"
					:class="!isCheckedOrderSn ? 'weui-btn_disabled' : '' "
					:disabled="!isCheckedOrderSn"
					@click="next">去开票</button>
		</div>
	</div>
</template>

<script>
    import { pay } from "../../../../api/coupon/platePay";
    import {payParkingRecord} from "../../../../api/coupon/parkingRecord";
	// import {getParkinglotConfigInfo } from "../../../api/coupon/userParkingFeeList";
	import {getParkinglotConfigInfo } from "../../../../api/coupon/userParkingFeeList";
    import {mapGetters, mapMutations} from 'vuex'

    export default {
        name: "index",
        data() {
            return {
				parkinglotId:undefined,
                isTicketOut: undefined,
                isCheckedOrderSn: false,
                isClickShowColl: false,
                recordList: [],
                scrollOptions: {
                    click: true,
                    bounce: false
                },
                scrollCellOptions: {
                    click: true,
                    bounce: false,
                    stopPropagation: true
                },
            }
        },
        computed: {
            ...mapGetters(['userOpenid', 'clickMerRecord'])
        },
        created() {
            this.$nextTick(() => {
                this.$refs.scroll.refresh()
            });
            this.getRecord();
        },
        methods: {
            ...mapMutations({
                setTotalPrice: 'SET_TOTAL_PRICE',
                setReceiptOrderSnObj: "SET_RECEIPT_ORDERSN_OBJ",
                setReceiptParkinglotId: "SET_RECEIPT_PARKINGLOTID",
            }),
            handleClickCell(item) {
                item.isClickShowColl = !item.isClickShowColl
            },
            handleChecked(item) {
				console.log(item,'item');
				this.parkinglotId=item.parkinglotId
                this.setTotalPrice(parseFloat(item.money).toFixed(2));
                let obj = {};
                obj[item.id] = item.orderSn;
                this.setReceiptOrderSnObj(obj);
                this.setReceiptParkinglotId(item.parkinglotId);
              	this.isTicketOut = item.ticketOut;
                this.isCheckedOrderSn = true
			},
            getRecord() {
                payParkingRecord({openid: localStorage.getItem('userOpenId')||this.userOpenid  , typeSwitch: this.clickMerRecord ? 2 : 1}).then(res => {
                    if (res.code === 200) {
                        let recordList = res.data;
                        recordList.map(item => {
                            this.$set(item, 'isClickShowColl', false);
                        });
                        this.recordList = recordList;
                    }
                })
            },
            toCancle () {

			},
            toPay (item) {
                let orderForm = {
                    totalAmount: item.money,
                    parkinglotId: item.parkinglotId,
                    payType: 13,
                    orderSn: item.orderSn,
                    openId:localStorage.getItem('userOpenId')||this.userOpenid  
				};
                pay(orderForm).then(res =>{
                    if (res.code === 200){
                        this.$pay(res)
					}
				})
            },
            next () {
                if (this.isTicketOut == 1){
                    this.$weui.alert('已开票，请重新选择')
                } else {
					getParkinglotConfigInfo(this.parkinglotId).then(res=>{
					console.log(res,'获取开票信息');
					if (res.code==200) {

						// return
						this.$router.push({ name: 'receiptForWrite', params: { receiptType: 6,type:res.data.type } })
					}
				})

                    // this.$router.push({name:'receiptForWrite',params:{receiptType:6}})
                }
            }
        }
    }
</script>

<style scoped lang="stylus">
	@import "~common/stylus/variable.styl"
	.cube-scroll {
		position: relative;
		text-align: left;
		white-space: normal;
		max-height: 80%
		overflow hidden
		/*background: #ffffff;*/
		margin-bottom 20px
		.weui-cells {
			margin-top 0
			/*padding-bottom 110px*/
			.cube-cell-scroll {
				position: relative;
				text-align: left;
				white-space: normal;
				max-height: 150px
				overflow hidden
				.weui-cells-wrapper {
					width 100%
					padding 10px 5px
					margin-bottom 5px
					background-color #e6e6e6
					border-radius 5px
					box-sizing border-box
					display flex
					flex-direction column
					.main-info{
						display flex
						justify-content space-between
						align-items center
						span:first-child{
							font-size 18px
							color #000
						}
						span:last-child{
							font-size 16px
							color #6d6d6d
						}
					}
					.date-info{
						font-size 13px
						padding-top 5px
						display flex
						justify-content space-between
						align-items center
					}
				}
			}
			.cell-wrap {
				width 100%
				.cell-status {
					font-size 14px
					color #6d6d6d
					display flex
					align-items center
					justify-content space-between
					span:first-child {
						line-height 14px
						padding 4px
						display block
						/*border 1px solid #ccc*/
					}
				}
				.change-order{
					padding-bottom 5px
					display flex
					justify-content flex-end
					.weui-btn{
						font-size 12px
						font-weight 300
						margin 0
						margin-left 10px
						border 1px solid $color-green
						border-radius 20px
						background-color #ffffff
					}
				}
				.cell-plate {
					padding 5px 0
				}
				.cell-plate, .cell-time {
					display flex
					align-items center
					justify-content space-between
					span:first-child {
						font-size 24px
						font-weight 400
					}
					span:last-child {
						font-size 20px
					}
				}
				.cell-time {
					p:first-child {
						font-size 14px
						color #6d6d6d
					}
					.icon-arrow-bottom {
						color #6d6d6d
					}
				}
			}
			.cell-details-wrap {
				font-size 14px
				color #6d6d6d
				p {
					padding 5px 0
				}
			}
		}
		.reset {
			transition: all 1s
		}
		.spin {
			transform rotate(-180deg)
			transition: all 1s;
		}

		@keyframes slide-down {
			0% {
				transform: scale(1, 0);
			}
			100% {
				transform: scale(1, 1);
			}
		}
		@-webkit-keyframes slide-down {
			  0% {
				  -webkit-transform: scale(1, 0);
			  }
			  100% {
				  -webkit-transform: scale(1, 1);
			  }
		}
		.show {
			display: block;
			/*max-height: 110px*/
			transition: display .2s ease-in;
			transform-origin: 50% 0;
			animation: slide-down 0.2s ease-in;
			-webkit-animation: slide-down 0.2s ease-in;
		}

		.hidden {
			display: none;
			/*max-height: 0*/
			overflow: auto;
			transition: display .3s ease-out;
		}
		.no-data-wrap {
			padding-top 50%
			display flex
			justify-content center
			align-items center
			.weui-article {
				color $no-data-font-color
				h1 {
					font-size $no-data-font-size
				}
			}
		}
		.total-count {
			font-size: 14px
			padding: 10px 15px;
			text-align: right;
		}
		.weui-form__control-area{
			margin-top 0
			margin-bottom 0
		}
		.weui-cells:before{
			border-top none
		}
		.weui-cells__group_form .weui-cell{
			padding  16px
		}
		.weui-cells__group_form .weui-cells:after{
			left 0
			right 0
		}
	}
	.weui-btn-area{
		margin 10px
		.weui-btn{
			width: 100%;
		}
	}

</style>

